import React from 'react';
import { ProductListHeder, ProductListNum, ProductListOption } from '../../pages/product/ProductList';
import { BtnListType } from '../Button';

const imgURL = '/images';

interface headerType {
  totalCount: number;
  type: string;
  setType: React.Dispatch<React.SetStateAction<string>>;
}

export default function MyshoppingProductHeader({ totalCount, type, setType }: headerType) {
  return (
    <ProductListHeder className="product_list_header">
      <ProductListNum>
        <span>{totalCount}</span>개의 상품
      </ProductListNum>

      <ProductListOption>
        <li>
          <BtnListType>
            <img
              onClick={() => {
                if (type === 'thumb') {
                  setType('list');
                } else {
                  setType('thumb');
                }
              }}
              src={`${type === 'thumb' ? `${imgURL}/icon_list.png` : `${imgURL}/icon_list_thumb.png`}`}
              alt="상품보기 썸네일형"
            />
          </BtnListType>
        </li>
      </ProductListOption>
    </ProductListHeder>
  );
}
